<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}位成员</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" :disabled="multiple" v-preventReClick @click="handleDelete">
            {{ cancelButtonText }}
          </el-button>
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column prop="no" label="工号" min-width="100">
          <template slot-scope="scope">
            <span>
              <el-link type="primary" @click="handleInfo(scope.row)">{{ scope.row.no }}</el-link>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称" min-width="140">
        </el-table-column>
        <el-table-column prop="mobile" label="联系方式" min-width="130" show-overflow-tooltip>
          <template slot-scope="scope">
              {{ scope.row.mobile??'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="sexName" label="性别" min-width="80" show-overflow-tooltip></el-table-column>
        <el-table-column prop="deptName" label="关联科室" min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.deptName??'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="warehouseName" label="关联库房" width="180" show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.warehouseInfos && scope.row.warehouseInfos.length > 0 ? scope.row.warehouseInfos.map(e => e.name).join(';') : '-'}}
            <!-- <el-tooltip effect="light" placement="bottom" popper-class="tooltip-content">
                <div slot="content" class="">
                  <div class="tooltip-text" v-for="item in scope.row.warehouseInfos" :key="item.id">
                    {{ item.name }}
                  </div>
                </div>
                <span>{{ scope.row.warehouseInfos.length }}</span>
              </el-tooltip> -->
            <!-- </template> -->
          </template>
        </el-table-column>
        <el-table-column prop="createdTime" label="创建时间" width="170">
          <template slot-scope="scope">
            {{ parseTime(new Date(scope.row.createdTime)) }}
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间" width="170">
          <template slot-scope="scope">
            {{ scope.row.updateTime?parseTime(new Date(scope.row.updateTime)):'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="stateName" label="状态" width="80">
          <template slot-scope="scope">
            <span :class="{
                enable: scope.row.state == 1,
                forbidden: scope.row.state == 0,
              }">{{ scope.row.stateName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="operation" fixed="right" label="操作" width="260">
          <template slot-scope="scope">
            <!-- <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button> -->
            <el-button v-if="tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
            <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">{{ scope.row.state === 0 ? "启用" : "禁用" }}</el-button>
            <el-button v-if="tableAcl.indexOf('UpdatePassword') != -1" type="text" v-preventReClick @click="showUpdatePassWordDialog(scope.row)" class="margin-left20 color-blue">修改密码</el-button>
          </template>
        </el-table-column>
      </el-table>

      <info :show="showInfo" :id="id" @handleClose="closeInfo"></info>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>

    <!-- 修改密码弹出框 -->
    <el-dialog title="修改密码" :visible.sync="updatePassWordVisible" width="30%">
      <el-form ref="form" :model="updatePassWordParams" :rules="updatePassWordRules" label-width="100px">
        <el-form-item label="密码" prop="passWord">
          <el-input type="password" v-model="updatePassWordParams.passWord"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="passWordConfirm">
          <el-input type="password" v-model="updatePassWordParams.passWordConfirm"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updatePassWord">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetUserList,
  SaveUser,
  SaveUserEncrypt,
  UpdateUserStatesById,
  UpdateUserPassWord,
  UpdateUserPassWordEncrypt
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import Info from "./info";

export default {
  mixins: [GetDataMixin],
  components: {
    Info,
  },
  data () {
    var validatePass = (rule, value, callback) => {
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{12,}$/;
      console.log(regex.test(value) ,value);

      if (value === '') {
        callback(new Error('请输入密码'))
      } else if ( !regex.test(value) ) {
        callback(new Error("密码需包含字母大小写数字特殊字符长度大于等于12位!"));
      } else {
        if (this.updatePassWordParams.passWordConfirm !== '') {
          this.$refs.form.validateField('passWordConfirm')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.updatePassWordParams.passWord) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      // 打开详情
      showInfo: false,
      id: 0,
      // 新增、编辑的数据
      form: {},
      // 多选框数据
      ids: [],
      multipleSelection: [],
      // 列表多选
      multiple: true,
      cancelButtonText: "禁用",
      updatePassWordVisible: false,
      updatePassWordRules: {
        passWord: [
          { validator: validatePass, trigger: 'blur' }
        ],
        passWordConfirm: [
          { validator: validatePass2, trigger: 'blur' }
        ]
      },
      updatePassWordParams: {
        id: 0,
        passWord: '',
        passWordConfirm: ''
      }
    };
  },
  methods: {
    handleSelectionChange (selection) {
      this.multipleSelection = selection;
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;

      this.cancelButtonText =
        selection && selection.length > 0 && selection[0].state == 0
          ? "启用"
          : "禁用";
    },
    // 获取列表
    getData () {
      GetUserList(this.query).then((res) => {
        this.tableData = res.returnData.data;
        this.total = res.returnData.totalCount;
      });
    },
    // 查看信息
    handleInfo (row) {
      this.id = row.id;
      this.showInfo = true;
    },
    closeInfo () {
      this.showInfo = false;
      this.id = 0;
    },
    // 新建
    handleAdd () {
      // this.open = true
      // this.title = "新建"
      // this.resetForm()
      this.$router.push("/user-edit");
    },
    // 编辑
    handleUpdate (row) {
      // this.resetForm()
      // this.form = JSON.parse(JSON.stringify(row));
      // this.form.state = Boolean(this.form.state);
      // this.open = true;
      // this.title = "编辑"
      this.$router.push("/user-edit?id=" + row.id);
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.form.state = Number(this.form.state);
        let encyptBody = this.encryptCBC(JSON.stringify(this.form))
      SaveUserEncrypt({encyptBody})
          .then((res) => {
            // if (res.successful == false) {
            //   this.$my_message(res.errorMessage,"error")
            //   return;
            // }
            this.open = false;
            this.$my_message(`执行成功`, "success");
            this.getData();
          })
          .finally((res) => {
            this.form.state = Boolean(this.form.state);
          });
      });
    },
    resetForm () {
      this.form = {
        name: "",
        state: true,
        orgCode :sessionStorage.getItem('orgId'),
      };
    },
    // 取消编辑部门
    cancel () {
      this.open = false;
    },
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },

    // 删除部门
    handleDelete (row) {
      let ids = [];
      let state = 0;
      if (row && row.id) {
        ids = [row.id];
        state = row.state == 1 ? 0 : 1;
      } else {
        state = this.multipleSelection[0].state == 1 ? 0 : 1;
        let stateDatas = this.multipleSelection.filter((e) => e.state == state);
        if (stateDatas.length >= 1) {
          this.$my_message("请只选择一种状态的数据！", "warning");
          return;
        }
        ids = this.ids;
      }

      this.$my_confirm("此操作将切换状态, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          return UpdateUserStatesById({ ids, state });
        })
        .then(() => {
          this.$my_message(`操作成功！`, "success");
          this.ids = []
          this.multipleSelection = []
          this.multiple = true;
          if (this.$refs.multipleTable) {
            this.$refs.multipleTable.clearSelection()
          }
          this.getData();
        })
        .catch(() => { });
    },
    // 重置
    reset () {
      this.query.keyWord = "";
      this.$set(this.query, "pageIndex", 1);
      this.$set(this.query, "pageSize", 10);
      this.ids = []
      this.multipleSelection = []
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
    // deptChange (val) {
    //   this.form.parentId = val
    // },
    // userChange (val) {
    //   this.form.leader = val
    // }
    showUpdatePassWordDialog (row) {
      this.updatePassWordParams = {
        id: row.id,
        passWordConfirm: '',
        passWord: ''
      }
      this.updatePassWordVisible = true
    },
    updatePassWord () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        let params = JSON.parse(JSON.stringify(this.updatePassWordParams))
        params.passWord = this.encryptCBC(params.passWord)
        params.passWordConfirm = this.encryptCBC(params.passWordConfirm)
        let encyptBody = this.encryptCBC(JSON.stringify(params))
        UpdateUserPassWordEncrypt({encyptBody})
          .then(res => {
            this.$my_message(`修改成功！`, "success");
            this.updatePassWordVisible = false
          })
      })

    }
  },
  mounted () {
    // console.log(sessionStorage.getItem('dept'), sessionStorage.getItem('warehouse'))
    this.getData();
    // this.getDepts('');
    // this.getUsers('');
  },
};
</script>

<style lang="scss" scoped></style>
